import React from 'react';
import { FiMenu } from 'react-icons/fi';
import { ReadingModeToggle, UserAvatar } from '../common';
import { SeasonalDecor, useMediaQuery } from '../../seasonal';

interface HeaderProps {
  title: string;
  onMenuClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, onMenuClick }) => {
  // Bajo 992px la cabecera no monta la decoración (un <img> con display: none se
  // descarga igual); la misma cadena que la media query del SCSS, que queda de respaldo.
  const isMobile = useMediaQuery('(max-width: 991.98px)');
  return (
    <header className="header">
      <div className="d-flex align-items-center gap-3">
        <button
          className="btn btn-link d-lg-none p-0"
          onClick={onMenuClick}
          aria-label="Toggle menu"
        >
          <FiMenu size={24} />
        </button>
        <h1 className="header-title">{title}</h1>
      </div>

      {/* Decoración de temporada: entre el título y las acciones. Sin temporada, nada. */}
      <SeasonalDecor slot="header" hidden={isMobile} />

      <div className="header-actions d-flex align-items-center gap-3">
        <ReadingModeToggle />
        <UserAvatar />
      </div>
    </header>
  );
};

export default Header;
